import slice from './slice';

export const { setLoading } = slice.actions;
